module.exports = __webpack_public_path__ + "img/retro-mal.6535cc95.png";